module.exports = __webpack_public_path__ + "static/media/stadtbahn.9074cd9a.svg";